import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import Logo from '../components/Logo';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, loginWithGoogle, resolveGoogleRedirect, currentUser } = useAuth();
  const navigate = useNavigate();

  // Googleのリダイレクトから戻ってきた直後にエラーがあれば拾う
  useEffect(() => {
    (async () => {
      try {
        await resolveGoogleRedirect();
      } catch {
        setError('Googleログインに失敗しました。');
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ログイン状態が確定したら（リダイレクト経由・通常ログイン問わず）ダッシュボードへ
  useEffect(() => {
    if (!currentUser) return;
    (async () => {
      try {
        setLoading(true);
        const storeDoc = await getDoc(doc(db, 'stores', currentUser.uid));
        if (!storeDoc.exists()) {
          await setDoc(doc(db, 'stores', currentUser.uid), {
            storeName: currentUser.displayName || '新しいお店',
            email: currentUser.email,
            plan: 'free',
            createdAt: new Date(),
          });
        }
        navigate('/dashboard');
      } catch {
        setError('ログイン処理でエラーが発生しました。');
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      await login(email, password);
      navigate('/dashboard');
    } catch {
      setError('ログインに失敗しました。メールアドレスとパスワードを確認してください。');
    }
    setLoading(false);
  }

  async function handleGoogle() {
    try {
      setError('');
      setLoading(true);
      await loginWithGoogle();
      // ここから先はGoogleへリダイレクトするため、戻ってきた後の処理は上のuseEffectで行う
    } catch {
      setError('Googleログインに失敗しました。');
      setLoading(false);
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}><Logo size={28} /></div>
        <p style={styles.subtitle}>ログイン</p>
        {error && <div style={styles.error}>{error}</div>}

        <button onClick={handleGoogle} disabled={loading} style={styles.btnGoogle}>
          <img src="https://www.google.com/favicon.ico" alt="G" style={styles.googleIcon} />
          Googleでログイン
        </button>

        <div style={styles.divider}><span>または</span></div>

        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>メールアドレス</label>
            <input type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input} required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>パスワード</label>
            <input type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input} required />
          </div>
          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>
        <p style={styles.link}>
          アカウントをお持ちでない方は <Link to="/register">新規登録</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#f8f9fa' },
  card: { background: '#fff', padding: '40px', borderRadius: '16px',
    width: '100%', maxWidth: '400px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' },
  logoWrap: { display: 'flex', justifyContent: 'center', marginBottom: '16px' },
  subtitle: { textAlign: 'center', color: '#666', margin: '0 0 24px', fontSize: '16px' },
  error: { background: '#fee', color: '#c00', padding: '12px',
    borderRadius: '8px', marginBottom: '16px', fontSize: '14px' },
  btnGoogle: { width: '100%', padding: '12px', background: '#fff', color: '#333',
    border: '2px solid #ddd', borderRadius: '8px', cursor: 'pointer',
    fontSize: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' },
  googleIcon: { width: '18px', height: '18px' },
  divider: { textAlign: 'center', margin: '20px 0', color: '#999',
    borderTop: '1px solid #eee', paddingTop: '20px' },
  field: { marginBottom: '16px' },
  label: { display: 'block', marginBottom: '6px', fontSize: '14px', color: '#333' },
  input: { width: '100%', padding: '12px', border: '1px solid #ddd',
    borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '14px', background: '#2d6a4f', color: '#fff',
    border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer', marginTop: '8px' },
  link: { textAlign: 'center', marginTop: '20px', fontSize: '14px', color: '#666' },
};

export default Login;
